module.exports = __webpack_public_path__ + "static/media/result-1.99ace811.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/result-1.png
// module id = 137
// module chunks = 0